import React, { useMemo } from 'react';
import { Alert, Modal, Select, Tag } from 'antd';

const { Option } = Select;

function cartesian(arrays) {
    if (!arrays.length) return [];
    return arrays.reduce((acc, current) => {
        const next = [];
        acc.forEach((a) => {
            current.forEach((b) => {
                next.push(a.concat([b]));
            });
        });
        return next;
    }, [[]]);
}

export default function QuickGenerateVariantModal(props) {
    const { visible, onClose, properties = [], selectedProperties = {}, onSelectValues, onConfirm } = props;

    const previewCombos = useMemo(() => {
        const entries = Object.keys(selectedProperties)
            .map((name) => ({ name, values: selectedProperties[name] || [] }))
            .filter((item) => item.values.length > 0);
        if (entries.length === 0) return [];
        return cartesian(entries.map((item) => item.values)).map((combo) =>
            combo.map((value, index) => `${entries[index].name}: ${value}`).join(' | ')
        );
    }, [selectedProperties]);

    return (
        <Modal
            title="Tạo nhanh biến thể"
            visible={visible}
            onCancel={onClose}
            onOk={onConfirm}
            okButtonProps={{ disabled: properties.length === 0 }}
            width={720}
        >
            {properties.length === 0 ? (
                <Alert type="info" message="Chọn thuộc tính trong drawer trước khi tạo nhanh biến thể" showIcon style={{ marginBottom: 16 }} />
            ) : null}
            {properties.map((property) => (
                <div key={property._id || property.name} style={{ marginBottom: 16 }}>
                    <div style={{ marginBottom: 8, fontWeight: 600 }}>{property.name}</div>
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder={`Chọn value cho ${property.name}`}
                        value={selectedProperties[property.name] || []}
                        onChange={(values) => onSelectValues(property.name, values)}
                        disabled={!property.values || property.values.length === 0}
                    >
                        {(property.values || []).map((value) => <Option key={value} value={value}>{value}</Option>)}
                    </Select>
                    {!property.values || property.values.length === 0 ? (
                        <div style={{ color: '#9ca3af', marginTop: 6 }}>Thuộc tính này chưa có giá trị trong thư viện</div>
                    ) : null}
                </div>
            ))}
            <div>
                <div style={{ marginBottom: 8, fontWeight: 600 }}>Preview tổ hợp</div>
                <div>
                    {previewCombos.length === 0 ? 'Chưa có tổ hợp nào' : previewCombos.map((item) => <Tag key={item} style={{ marginBottom: 8 }}>{item}</Tag>)}
                </div>
            </div>
        </Modal>
    );
}
